import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { keyNamesForValues, installmentsStatus } from './constants'
import { checkAnyInstallmentUnPaidHelper, findCourseById, oldPaymentGatewaysToNewOne } from '@/utils/index'
import { getInvoiceApiCall } from "@/services/api"
import EmptyModal from '@/components/common/emptyModal/emptyModal'
import { useNavigate } from 'react-router-dom';

import EnrolledView from './view';
import { toast } from 'sonner';

export default function Enrolled(props: any) {
    const navigate = useNavigate();

    const { common, timeline } = useLocalTranslation();

    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);

    const [anyInstallmentUnPaid, setAnyInstallmentUnPaid] = useState(false)
    const [showModal, setShowModal] = useState(false);
    const [payInfoPopupContent, setPayInfoPopupContent] = useState({})
    const [getInvoiceErr, setGetInvoiceErr] = useState({})
    const [getInvoiceBtnLoading, setGetInvoiceBtnLoading] = useState("")

    useEffect(() => {
        checkAnyInstallmentUnPaid()
    }, [])


    const downloadInvoice = async (invoiceData: any, source: any, pdfFileName: string) => {

        let orderId = ""
        let invoiceDocId = ""
        // debugger
        if (source === "withOutInstallment"
            || source === "fullPayment"
            || source === "extendedOrder") {
            if (invoiceData.orderId) {
                orderId = invoiceData.orderId
                invoiceDocId = invoiceData._id
            }
        } else {
            if (invoiceData.invoiceDetails && invoiceData.invoiceDetails.orderId) {
                orderId = invoiceData.invoiceDetails.orderId
                invoiceDocId = invoiceData.invoiceDetails._id
            }
        }


        if (orderId === "") {
            toast.error(common.statusText.noOrderIdFound)
            return
        }


        if (orderId != getInvoiceBtnLoading) {
            setGetInvoiceErr({})
            // debugger

            setGetInvoiceBtnLoading(invoiceDocId)
            

            if (orderId !== "") {
                const getInvoiceApiCallStatus = await getInvoiceApiCall(orderId)
                // debugger
                if (getInvoiceApiCallStatus !== null) {
                    const pdfBlob = new Blob([getInvoiceApiCallStatus], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(pdfBlob);
                    const link = document.createElement('a');
                    link.href = url;                
                    // link.download = `invoice_${orderId}.pdf`;
                    link.download = pdfFileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } else {
                    setGetInvoiceErr({
                        msg: common.statusText.issueInDownloadingPdf,
                        orderId: orderId
                    })
                }
            } else {
                toast.error(common.statusText.issueInDownloadingInvoice)
            }
            setGetInvoiceBtnLoading("")
        }
    }


    function sumUnpaidAmounts() {
        const installments = timelineDetails.installmentSchedule
        if (!installments || installments.length === 0) return 0

        // API installment.amount already includes surcharge.
        // Surcharge was calculated as % of the ORIGINAL course total (not of each installment),
        // then added to every installment.
        //
        // Example: total 100, 4 x 25% installments, 5% surcharge of 100 (= 5 each)
        // → each installment amount = 30, grand schedule total = 120
        // → after 1 paid (30), full pay remaining base = 75 (not 90)
        //
        // originalTotal = sum(all amounts) / (1 + sum(all additionalCharges%) / 100)
        // remainingSurcharge = originalTotal * sum(unpaid additionalCharges%) / 100
        // fullPay = sum(unpaid amounts) - remainingSurcharge

        const sumAllAmounts = installments.reduce(
            (sum: number, item: { amount: number }) => sum + (Number(item.amount) || 0),
            0
        )
        const totalChargePercent = installments.reduce(
            (sum: number, item: { additionalCharges?: number }) =>
                sum + (Number(item.additionalCharges) || 0),
            0
        )

        const originalTotal = totalChargePercent > 0
            ? sumAllAmounts / (1 + totalChargePercent / 100)
            : sumAllAmounts

        const unpaid = installments.filter(
            (item: { status: any }) => item.status === installmentsStatus.pending
        )
        const sumUnpaidWithCharges = unpaid.reduce(
            (sum: number, item: { amount: number }) => sum + (Number(item.amount) || 0),
            0
        )
        const remainingChargePercent = unpaid.reduce(
            (sum: number, item: { additionalCharges?: number }) =>
                sum + (Number(item.additionalCharges) || 0),
            0
        )
        const remainingSurcharge = originalTotal * (remainingChargePercent / 100)

        return Math.ceil(sumUnpaidWithCharges - remainingSurcharge)
    }

    function sumPaidAmounts() {
        const installments = timelineDetails.installmentSchedule
        const currencySymbol = timelineDetails.currencySymbol
        let amt = 0
        if (installments && installments.length > 0) {
            amt = installments
                .filter((item: { status: any; }) => item.status === installmentsStatus.paid)
                .reduce((sum: any, item: { amount: any; }) => sum + item.amount, 0);
        } else if (timelineDetails.orderDetails) {
            amt = timelineDetails.orderDetails.grandTotal
        }
        return currencySymbol + amt
    }


    function getFirstUnPaidAmt() {
        const installments = timelineDetails.installmentSchedule
        const currencySymbol = timelineDetails.currencySymbol
        let amt = ''
        if (installments && installments.length > 0) {
            const unpaid = installments.find((item: { status: any; }) => item.status === installmentsStatus.pending);
            if (unpaid && unpaid.amount) {
                amt = currencySymbol + unpaid.amount
            }
        }
        return amt
    }


    const getLastInstallmentDueDate = () => {
        let dueDate = ""
        const installments = timelineDetails.installmentSchedule
        if (installments && installments.length > 0) {
            dueDate = installments[installments.length - 1]["dueDate"]
        }
        return dueDate
    }



    const checkAnyInstallmentUnPaid = () => {
        let unpaid = checkAnyInstallmentUnPaidHelper(timelineDetails.installmentSchedule)
        if (unpaid) {
            setAnyInstallmentUnPaid(true)
        }
        return unpaid
    }


    const countUnpaidInstallments = () => {
        let countUnpaidInstallments = 0
        const installments = timelineDetails.installmentSchedule
        if (installments && installments.length > 0) {
            countUnpaidInstallments = installments.filter((item: { status: any; }) => item.status === installmentsStatus.pending).length;
        }
        return countUnpaidInstallments
    }

    const countPaidInstallments = () => {
        let countUnpaidInstallments = 0
        const installments = timelineDetails.installmentSchedule
        if (installments && installments.length > 0) {
            countUnpaidInstallments = installments.filter((item: { status: any; }) => item.status === installmentsStatus.paid).length;
        }
        return countUnpaidInstallments
    }


    const payInfoPopup = (source: string) => {
        let data = {
            title: "",
            content: ""
        }
        data.content = `<p>${timeline.enrolledSection.popUpInfo}</p>`
        if (source === "warning") {
            data.content = `<p>${timeline.enrolledSection.popUpWarning1}</p><p>${timeline.enrolledSection.popUpWarning1_1}</p>`
        }
        setPayInfoPopupContent(data)
        handleOpenModal()
    }
    const handleOpenModal = () => {
        setShowModal(true)
    };
    const handleCloseModal = (status: string) => {
        setShowModal(false)
    }


    const updateInstallmentStatusV1 = (
        installments: any,
        targetNumber: number,
        newStatus: string
    ) => {
        return installments.map((installment: { installmentNumber: number; }) =>
            installment.installmentNumber === targetNumber
                ? { ...installment, status: newStatus }
                : installment
        );
    }

    function updateInstallmentStatus(
        installments: any,
        targetNumber: number,
        newStatus: string,
        markAllPaid: boolean
    ) {
        return installments.map((installment: { installmentNumber: number; }) => {
            if (markAllPaid) {
                return { ...installment, status: newStatus };
            }
            if (installment.installmentNumber === targetNumber) {
                return { ...installment, status: newStatus };
            }
            return installment;
        });
    }


    const handleInstallmentPayment = (installmentDetails: any, paymentType: string) => {
        /*
            1. Orignal Amout :  this is without coupon or this continent price 
            2. Net Amout  : after coupon applied or other included offers and discount
            3. Grand Total :  after coupon applied or other included offers and discount
            4. GST :  Net total ka 18%
            5. Subtotal  :  Minus GST Amount
        */
        // MARK ALL PAID IN CASE OF IN_CASE_FULL_PAY
        let updatedInstallments = {}
        if (paymentType === "fullPayment") {
            updatedInstallments = updateInstallmentStatus(timelineDetails.orderDetails.installmentSchedule, installmentDetails.installmentNumber, "paid", true);
        } else {
            updatedInstallments = updateInstallmentStatus(timelineDetails.orderDetails.installmentSchedule, installmentDetails.installmentNumber, "paid", false);
        }
        let gstRate = 18;
        if (timelineDetails.orderDetails.paymentGateway === "stripe") {
            gstRate = 9;
        }
        // debugger
        const gst = (installmentDetails.amount * gstRate) / 100
        const subTotal = installmentDetails.amount - gst

        let useParentDocumentId = timelineDetails.orderDetails._id
        if (!timelineDetails.orderDetails.isParent && timelineDetails.orderDetails.parentDocumentId) {
            useParentDocumentId = timelineDetails.orderDetails.parentDocumentId
        }
        const currentCourseObj = findCourseById(timelineDetails.orderDetails.courses, timelineDetails.courseId)
        // console.log(timelineDetails.orderDetails)
        // debugger
        const tentativeOrder: any = {
            // paymentStructure : full
            // orderType : course || examReattempt
            // totalInstallments 0 
            // paidInstallments 0 
            // installmentNumber 0
            // amount 300
            // installmentSchedule
            // installmentOption
            // purchaseId : purchaseId

            paymentStructure: paymentType === 'installment' ? 'installment' : 'remainingBalance',
            paymentStatus: 'pending',
            totalInstallments: timelineDetails.orderDetails.totalInstallments,
            paidInstallments: paymentType === 'installment' ? timelineDetails.orderDetails.paidInstallments + 1 : timelineDetails.orderDetails.totalInstallments,
            isParent: false,
            parentOrderId: timelineDetails.orderDetails.orderId,
            parentDocumentId: useParentDocumentId.toString(),
            // parentDocumentId: timelineDetails.orderDetails._id.toString(),
            installmentNumber: paymentType === 'installment' ? installmentDetails.installmentNumber : 0,
            offerDiscountInNumbers: 0,
            offerDiscountInPercentage: 0,
            couponDiscountInNumbers: 0,
            couponDiscountInPercentage: 0,
            gatewayDiscountPercentage: 0,
            gatewayDiscountInNumber: 0,
            originalAmount: Math.round(installmentDetails.amount), // total amount
            grandTotal: Math.round(installmentDetails.amount), // after discount
            netTotal: Math.round(installmentDetails.amount), // same as grand
            GST: Math.round(gst), // 18 % netTotal ... stripe 9%
            subTotal: Math.round(subTotal), // after gst
            continent: timelineDetails.orderDetails.courses[0].pricingPlan.prices.continent,
            countryName: timelineDetails.orderDetails.courses[0].pricingPlan.prices.countryName,
            currencySymbol: timelineDetails.orderDetails.courses[0].pricingPlan.prices.symbol,
            currencyCode: timelineDetails.orderDetails.courses[0].pricingPlan.prices.code,
            installmentSchedule: updatedInstallments,
            installmentOption: timelineDetails.orderDetails.installmentOption,
            courses: timelineDetails.orderDetails.courses,
            coursesMnemonic: timelineDetails.orderDetails.coursesMnemonic
        }
        // debugger
        // console.log(tentativeOrder)

        // console.log('installmentDetails :', tentativeOrder, timelineDetails.orderDetails.paymentGateway)
        navigate('/payment', {
            state: {
                tentativeOrder: tentativeOrder,
                paymentGateway: oldPaymentGatewaysToNewOne(timelineDetails.orderDetails.paymentGateway),
            },
        });
    }


    const valueForView = useMemo(() => ({
        [keyNamesForValues.getFirstUnPaidAmt]: getFirstUnPaidAmt(),
        [keyNamesForValues.sumUnpaidAmounts]: sumUnpaidAmounts(),
        [keyNamesForValues.getLastInstallmentDueDate]: getLastInstallmentDueDate(),
        [keyNamesForValues.sumPaidAmounts]: sumPaidAmounts(),
        [keyNamesForValues.countUnpaidInstallments]: countUnpaidInstallments(),
    }), [timelineDetails]);

    return (
        <>
            <EnrolledView
                timelineDetails={timelineDetails}
                anyInstallmentUnPaid={anyInstallmentUnPaid}
                payInfoPopup={payInfoPopup}
                valueForView={valueForView}
                downloadInvoice={downloadInvoice}
                getInvoiceErr={getInvoiceErr}
                getInvoiceBtnLoading={getInvoiceBtnLoading}
                handleInstallmentPayment={handleInstallmentPayment}
            />

            <EmptyModal
                show={showModal}
                handleClose={handleCloseModal}
                popupInfo={payInfoPopupContent}
            />

        </>
    );
};


